import { getMetaDatabaseActionCreators, getMetaDatabaseActionTypes } from './utils';

/**
 * Action Types
 */
export const ACTIONS = getMetaDatabaseActionTypes('REGIONS');

/**
 * Action Creators
 */
export const actionCreators = getMetaDatabaseActionCreators('REGIONS');

/**
 * Action Dispatchers
 */
